// Registers this phone as a device row on sign-in (Android TWA / iOS PWA /
// mobile browser) — the mobile counterpart of the desktop app's
// /api/devices/self-register flow. Desktop browsers are skipped; desktops
// register through the desktop app instead.
//
// Identity: phones have no RMM agent, so we persist a UUID in localStorage
// and the backend stores it as devices.hardware_id "mobile-<uuid>". Repeat
// sign-ins update the same row; the JWT stamps contact/agent + client.
const API_URL = process.env.REACT_APP_API_URL || "";

function makeId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  const b = new Uint8Array(16);
  window.crypto.getRandomValues(b);
  return Array.from(b, x => x.toString(16).padStart(2, "0")).join("");
}

// The combined Android app (v2+) launches the TWA with ?midtc_native_id=<ANDROID_ID>
// so the web login registers against the SAME device row the native agent created
// (both sides use hardware_id "mobile-<id>"). Capture it at module load, before any
// router navigation strips the query string.
try {
  const nid = new URLSearchParams(window.location.search).get("midtc_native_id");
  if (nid && /^[0-9a-f-]{8,64}$/i.test(nid)) localStorage.setItem("midtc_mobile_device_id", nid.toLowerCase());
} catch {}

export async function registerMobileDevice(token) {
  try {
    if (!token) return;
    const ua = navigator.userAgent;
    // iPadOS Safari defaults to DESKTOP mode and reports UA "Macintosh" with NO
    // "iPad" token — so the naive UA test misses every iPad. A touch-capable
    // "Macintosh" is really an iPad. Detect that explicitly.
    const isIPadOS = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
    const isPhoneUA = /android|iphone|ipad|ipod/i.test(ua);
    if (!isPhoneUA && !isIPadOS) return;

    let id = localStorage.getItem("midtc_mobile_device_id");
    if (!id) { id = makeId(); localStorage.setItem("midtc_mobile_device_id", id); }

    const isIOS = /iphone|ipad|ipod/i.test(ua) || isIPadOS;
    let model = "", osVersion = "";
    try {
      if (navigator.userAgentData?.getHighEntropyValues) {
        const d = await navigator.userAgentData.getHighEntropyValues(["model", "platformVersion"]);
        model = d.model || "";
        osVersion = d.platformVersion || "";
      }
    } catch {}
    if (!model) model = isIOS ? ((/ipad/i.test(ua) || isIPadOS) ? "iPad" : "iPhone") : "Android Device";
    if (!osVersion) {
      const m = ua.match(isIOS ? /OS (\d+[._]\d+)/ : /Android ([\d.]+)/);
      osVersion = m ? m[1].replace(/_/g, ".") : "";
    }

    await fetch(`${API_URL}/api/devices/mobile-register`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({
        mobile_id: id,
        device_name: model,
        os: isIOS ? "iOS" : "Android",
        os_version: osVersion,
        model,
      }),
    });
  } catch {} // best-effort — never block sign-in
}
